import PortalDescription from './PortalDescription.jsx';

import './portal-description-media-screen.scss';

export default PortalDescription;
